import script from "./ReturnGeneralBill.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnGeneralBill.vue?vue&type=script&setup=true&lang=js"

import "./ReturnGeneralBill.vue?vue&type=style&index=0&id=46a582df&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a582df"]])

export default __exports__